import React, {useState, useEffect} from "react";
import { Typography, CardContent, Card, CardMedia, Box } from "@mui/material";
import { Link } from 'react-router-dom';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../../../firebase/firebaseConfig";

const CardVision = () => {
    const [vision, setVision] = useState([]);

    useEffect(() => {
        onSnapshot(collection(db, 'visioncalocho'),
            (snapshot) => {
                const arregloVision = snapshot.docs.map((docVision) => {
                    return {...docVision.data(), id: docVision.id};
                })
    
                setVision(arregloVision);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);  

    return(
        <Box sx={{ width: '100%', }}>                    
            {vision.map((infovision) => (

            <Link style={{ textDecoration: 'none' }} key={infovision.id}>            
                <Card sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexDirection: {
                            xs: 'column', // Cambia a columnas en dispositivos móviles
                            sm: 'row', 
                        }
                    }}>
                    <CardMedia
                        component="img"
                        sx={{ width: { xs: 'none', sm: '25%'}, height: { xs: '50', sm: '25%'}, display: { xs: 'flex', sm: 'flex' } }}
                        image={infovision.imagen}
                        alt={infovision.titulo}
                        style={{ 
                            alignItems: {xs: 'center', sm: 'center'} , 
                            justifyContent: {xs: 'center', sm: 'center'},
                            alignContent: {xs: 'center', sm: 'center'},
                            textAlign: {xs: 'center', sm: 'center'},
                            borderRadius: '1%',
                        }}
                    />
                    <CardContent  
                        sx={{ 
                            display: "flex", 
                            justifyContent: 'center' ,
                            flexDirection: 'column',
                            width: '76%',
                        }}
                    >
                        <Typography variant="h4" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '1.4rem', sm: '1.6rem', md: '1.8rem' }, 
                            textAlign: 'center'
                        }}>
                            {infovision.titulo}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ 
                            marginBottom: { xs: 1, sm: 2 },
                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                            textAlign: 'center'
                        }}>
                            {infovision.descripcion}
                        </Typography>
                    </CardContent>
                </Card>
            </Link>
            ))}

        </Box>
    );
}

export default CardVision;